interface ILocalStorageItem {
    value: string;
    expirationDate: Date;
}

export function setInLocalStorage(name: string, value: string, nDays: number) {
    const date = new Date();
    date.setDate(date.getDate() + nDays);

    const data: ILocalStorageItem = {
        value: value,
        expirationDate: date,
    };
    localStorage.setItem("cookie-" + name, JSON.stringify(data));
}

export function getFromLocalStorage(name: string): string | null {
    const item = JSON.parse(localStorage.getItem("cookie-" + name)!) as ILocalStorageItem;

    if (item !== null && new Date(item.expirationDate).getTime() >= new Date().getTime()) {
        return item.value;
    }

    return null;
}
